import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Select } from 'antd';
import classNames from 'classnames';
import { setMomentLocaleOnLanguageChange } from './helpers';
import { LANGUAGE_OPTIONS, orderOptions } from './constants';
import { getDirection, setDirection } from '../../../../helpers';
import s from './LanguageSelect.module.scss';
const { Option } = Select;
const LanguageSelect = ({ className }) => {
    var _a, _b, _c;
    const { i18n } = useTranslation();
    const dir = getDirection();
    const [language, setLanguage] = useState(i18n.language + '-' + dir);
    const defaultLanguage = localStorage.getItem('currentLanguage') || language.split('-')[0];
    const defaultDirection = localStorage.getItem('currentDirection') || dir;
    const envDefault = (_c = (_b = (_a = window.env) === null || _a === void 0 ? void 0 : _a.initial_settings) === null || _b === void 0 ? void 0 : _b.defaultLanguage) !== null && _c !== void 0 ? _c : 'he';
    const orderedOptions = useMemo(() => orderOptions(LANGUAGE_OPTIONS, envDefault), [envDefault]);
    const handleChange = (value) => {
        const [language, dir] = value.split('-');
        setLanguage(value);
        setDirection(dir);
        localStorage.setItem('currentLanguage', language);
        localStorage.setItem('currentDirection', dir);
        i18n.changeLanguage(language);
    };
    useEffect(() => {
        setMomentLocaleOnLanguageChange(i18n.language);
    }, [i18n.language]);
    return (React.createElement(Select, { className: classNames(s.select, className), onChange: handleChange, value: `${defaultLanguage}-${defaultDirection}`, popupClassName: s.dropdown, size: "small" }, orderedOptions.map((opt) => (React.createElement(Option, { key: opt.value, value: opt.value }, opt.label)))));
};
export default LanguageSelect;
